/* eslint-disable global-require */
import React from 'react'
import Nav from './Nav'
import './index.scss'
import Clock from './Clock/Clock'
import Prize from './Prize/Prize'
import ColumnSection from './Section/Section'
import { getQueryVariable } from '../../utils'

class Agora extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activityDeadLine: '2020/4/25 14:00:00',
      itemArr: [
        {
          id: '#n1',
          name: '大赛简介'
        },
        {
          id: '#n2',
          name: '赛题介绍'
        },
        {
          id: '#n3',
          name: '议程安排'
        },
        {
          id: '#n4',
          name: '奖项设置'
        },
        {
          id: '#n5',
          name: '评委嘉宾'
        },
        {
          id: '#n6',
          name: '作品评选'
        }
      ]
    }
  }

  componentDidMount() {
    const script = document.createElement('script')

    script.src = `https://jinshuju.net/f/lnLr0K/embedded.js?banner=show&background=white&height=1206&x_field_1=${
      getQueryVariable('utm_source') || 'segmentfault'
    }`
    script.async = true

    document.getElementById('scriptForm').appendChild(script)
    document.title = 'RTC 2020 编程挑战赛春季赛'
  }

  render() {
    const { itemArr, activityDeadLine } = this.state
    return (
      <>
        <Nav itemArr={itemArr} />
        <header>
          <div className="container">
            <div className="font-weight-bold title-en">
              RTC 2020
              <br />
              Innovation Challenge
            </div>
            <div className="font-weight-bold title-zh">编程挑战赛春季赛</div>
            <div className="title-date">2020 年 3 月 10 日 ~ 4 月 25 日</div>
            <a
              className="btn btn-primary btn-xl mt-5 d-none d-md-inline-block"
              href="https://github.com/AgoraIO-Community/RTC-Hackathon"
              target="_blank"
            >
              赛后报道
            </a>
          </div>
        </header>
        <Clock deadline={activityDeadLine} />
        <ColumnSection hid="n1" title="大赛简介">
          <div className="line-height-175">
            <p>
              RTC（Real Time Communication）线上编程挑战赛，是声网 Agora 面向全球 RTC
              开发者、编程爱好者与极客举办的一场在线黑客马拉松。今年，我们将推出春季赛和秋季赛 2
              个赛季，每个赛季主题不同。更多有关秋季赛的报名和主题信息将在 7 月公开的大赛官网中展示。
            </p>
            <p>
              在全球疫情的大背景下，RTC技术被迅速的广泛应用于视频会议、在线教育、视频会议、在线医疗等实时互动场景中。而我们相信
              RTC 技术可以做的，远不止于此。发挥你的想象力，创造更多可以服务抗疫人群的创新应用。
            </p>
            <p>本次线上编程挑战赛将以「线上编程+线上提交+线上决赛」的方式进行。</p>
            <p className="mb-0">RTC（Real Time Communication）线上编程挑战赛秋季赛，7 月开启，拭目以待。</p>
          </div>
          <div
            style={{
              maxWidth: '720px',
              maxHeight: '520px'
            }}
            className="embed-responsive embed-responsive-16by9 mt-5"
          >
            <video src="https://media.segmentfault.com/pages/rtc-hackathon-2020.mp4" controls="controls">
              your browser does not support the video tag
            </video>
          </div>
        </ColumnSection>
        <ColumnSection hid="n2" title="赛题介绍">
          <div className="row">
            <div className="col-12 col-xl-6 mb-4 mb-xl-0">
              <div className="blueDiv line-height-175">
                <h3 className="text-primary mb-3">赛题一：为「多人通话」设计</h3>
                <p>
                  最近很多人都充分体验过了在线办公、视频会议。是不是发现上来看不懂怎么操作？很多功能找不到？界面布局不顺眼？这次给你一个创造的机会，基于我们提供的一个视频通话
                  Demo，给多人视频通话设计一个心目中的最佳 UI 并代码实现。
                </p>
                <h5 className="mt-4">作品要求</h5>
                <ul className="pl-4">
                  <li className="mb-2">必须选择官方指定的 Demo，并在此基础上做UI定制化开发</li>
                  <li className="mb-2">UI 设计创意内容不限，可以参考你认为 UX 体验好的任何相关作品</li>
                  <li className="mb-2">默认参赛者提交的 UI 设计原型所有权归参赛者所有，且不存在任何法律纠纷</li>
                  <li className="mb-2">最终参赛者提交的作品均会以 MIT 协议对外开源</li>
                </ul>
                <h5 className="mt-4">作品提交</h5>
                <ul className="pl-4">
                  <li className="mb-2">
                    在
                    <a href="https://rtcdeveloper.com/t/topic/17072" target="_blank">
                      RTC 论坛
                    </a>
                    下载对应平台的 Demo（只需下载自己参赛对应平台的 Demo 即可），然后在本地端进行开发
                  </li>
                  <li className="mb-2">
                    <a href="https://github.com/AgoraIO-Community/RTC-Hackathon" target="_blank">
                      Fork 官方仓库
                    </a>
                    至个人 github 仓库
                  </li>
                  <li className="mb-2">Clone 个人 github 仓库至本地</li>
                  <li className="mb-2">
                    在本地 UIChallengeProject
                    文件夹下创建个人项目文件夹，将本地的参赛作品放置个人项目文件夹（以团队名字或其他名字命名，切记不可以用原先下载
                    demo 的名字直接提交）
                  </li>
                  <li className="mb-2">Pull Request 提交本人作品至官方仓库</li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-xl-6">
              <div className="blueDiv line-height-175">
                <h3 className="text-primary mb-3">赛题二：使用 Agora SDK 开发应用</h3>
                <p>
                  因为这次疫情，火爆的场景除了在线教学、视频开会，还衍生出了云蹦迪、云聚会。在本次大赛中，你可以使用
                  Agora SDK ，赋予更多场景实时音视频互动的能力，还可以凭借这些创新，赢得大奖，赶紧行动吧～
                </p>
                <h5 className="mt-4">作品要求</h5>
                <ul className="pl-4">
                  <li className="mb-2">
                    参赛作品必须集成了声网Agora的其中一个 SDK，可以是音视频通话/直播 SDK、实时消息 SDK、录制
                    SDK、互动游戏 SDK、实时码流加速 SDK
                  </li>
                  <li className="mb-2">
                    参赛者开发新应用，或基于原创项目修改来参赛。评审最终会审核源代码，以保证公平。
                  </li>
                  <li className="mb-2">
                    应用可以是实现一个应用场景，如视频会议、在线课堂、直播连麦、音视频聊天、社交游戏、家居安防等，或解决一个现实存在的问题。
                  </li>
                  <li className="mb-2">
                    其他相关创意，可参考
                    <a href="https://github.com/AgoraIO-Community/AI-in-RTC_ProgrammingChallenge" target="_blank">
                      往届作品
                    </a>
                  </li>
                  <li className="mb-2">默认参赛者提交的作品不存在任何法律纠纷</li>
                  <li className="mb-2">参赛者提交作品的源代码均以 MIT 开源协议对外开源</li>
                </ul>
                <h5 className="mt-4">作品提交</h5>
                <ul className="pl-4">
                  <li className="mb-2">
                    <a href="https://github.com/AgoraIO-Community/RTC-Hackathon" target="_blank">
                      Fork 官方仓库
                    </a>
                    至个人 github 仓库
                  </li>
                  <li className="mb-2">Clone 个人 github 仓库至本地</li>
                  <li className="mb-2">
                    在本地 SDKChallengeProject 文件夹下创建个人项目文件夹，将参赛作品放置个人文件夹
                  </li>
                  <li className="mb-2">Pull Request 提交本人作品至官方仓库</li>
                </ul>
              </div>
            </div>
          </div>
        </ColumnSection>
        <ColumnSection hid="n3" title="议程安排">
          <div className="row w-100 text-center">
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/icon/edit.svg')} className="d-inline-block align-middle" alt="" />
              <div>官网报名</div>
              <div>3月10日 ~ 4月21日</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/icon/coder.svg')} className="d-inline-block align-middle" alt="" />
              <div>开发阶段</div>
              <div>3月10日 ~ 4月21日</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/icon/upload.svg')} className="d-inline-block align-middle" alt="" />
              <div>作品提交</div>
              <div>4月22日 ~ 4月24日</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/icon/show.svg')} className="d-inline-block align-middle" alt="" />
              <div>作品展示（线上决赛）</div>
              <div>4月25日</div>
            </div>
          </div>
          <div className="my-5 text-center line-height-175">
            <p>
              官网报名后，即可进入组队和开发阶段
              <br />
              作品提交后，不可修改，如有特殊需求可联系大赛组委会（见官网底部二维码）
              <br />
              作品展示即为最终决赛，详情可见决赛日程
            </p>
          </div>
          <h3 className="mb-4">决赛日程</h3>
          <div className="row w-100 text-center">
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/line.svg')} className="w-100" alt="" />
              <div>14:00 - 14:30</div>
              <div>开场</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/line.svg')} className="w-100" alt="" />
              <div>14:30 - 17:30</div>
              <div>作品展示</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/line.svg')} className="w-100" alt="" />
              <div>17:30 - 18:00</div>
              <div>作品评选</div>
            </div>
            <div className="col-6 col-xl-3">
              <img src={require('./assets/img/line.svg')} className="w-100" alt="" />
              <div>18:00</div>
              <div>结束</div>
            </div>
          </div>
        </ColumnSection>
        <ColumnSection hid="n4" title="奖项设置">
          <div className="mb-5">优秀队伍均可加入声网 Agora 招聘绿色通道</div>
          <h3 className="text-primary mb-4">UI 设计奖项</h3>
          <div className="prize mb-4 row w-100">
            <Prize type="gold" detail="￥10000，1 队" />
            <Prize type="silver" detail="￥5000，1 队" />
            <Prize type="bronze" detail="￥3000，1 队" />
            <Prize type="good" detail="￥1000，若干" />
          </div>
          <h3 className="text-primary my-4">应用开发奖项</h3>
          <div className="prize mb-4 row w-100">
            <Prize type="gold" detail="￥20000，1 队" />
            <Prize type="silver" detail="￥10000，1 队" />
            <Prize type="bronze" detail="￥5000，1 队" />
            <Prize type="good" detail="￥1000，若干" />
          </div>
        </ColumnSection>
        <ColumnSection hid="n5" title="评委嘉宾">
          <div className="flex-center my-4">
            <img
              width="160px"
              src={require('./assets/img/user/gongyuhua.jpg')}
              className="d-inline-block align-middle rounded mr-4"
              alt=""
            />
            <div>
              <h4 className="mb-3">龚宇华</h4>
              <p className="line-height-175">
                声网 Agora 资深 iOS 开发工程师。毕业于北京大学，在 2012 年进入互联网行业前是位自由撰稿人。2014
                年加入声网 Agora ，此前开发过移动端电子杂志阅读器，被网易云阅读等多个第三方应用指定集成。
              </p>
            </div>
          </div>
          <div className="flex-center my-4">
            <img
              width="160px"
              src={require('./assets/img/user/zhangqianze.jpg')}
              className="d-inline-block align-middle rounded mr-4"
              alt=""
            />
            <div>
              <h4 className="mb-3">张乾泽</h4>
              <p className="line-height-175">
                声网 Agora Web 研发工程师。毕业于英国牛津大学，原 SAP 软件工程师，主导 SAP Anywhere
                移动端架构设计开发。2017 年加入声网，现为声网 Agora 高级架构师，致力于 RTC
                技术在娱乐，直播等行业的应用与研发工作。
              </p>
            </div>
          </div>
          <div className="flex-center my-4">
            <img
              width="160px"
              src={require('./assets/img/user/qining.jpg')}
              className="d-inline-block align-middle rounded mr-4"
              alt=""
            />
            <div>
              <h4 className="mb-3">祁宁</h4>
              <p className="line-height-175">
                SegmentFault 思否 CTO，全栈工程师， 毕业于华中科技大学电信系，华科 Dian 团队第 98
                号成员。曾任职于阿里巴巴，开源内容系统 Typecho 发起人与核心组织者， 超过 10 年互联网产品研发经验。
              </p>
            </div>
          </div>
        </ColumnSection>
        <ColumnSection hid="n6" title="作品评选">
          <div className="container text-center">
            评委会根据「代码质量」「视觉设计」「用户体验」「作品完成度」「创意度」「潜在商业价值」等多个维度进行考量。
          </div>
          <div className="mt-5">
            <div className="row">
              <div className="col-12 col-xl-6 mb-4 mb-xl-0">
                <div className="blueDiv line-height-175">
                  <h3 className="text-primary mb-4">赛题一：为「多人通话」设计</h3>
                  <ul className="pl-4">
                    <li className="mb-4">
                      <strong className="d-block text-white">用户体验（30%）</strong>
                      <span className="d-block">
                        参赛团队提供的作品的用户友好度，具体体现在是否简单易懂、友好交互等。
                      </span>
                    </li>
                    <li className="mb-4">
                      <strong className="d-block text-white">视觉设计（30%）</strong>
                      <span className="d-block">
                        参赛团队提供的作品的视觉体验，包括创意、视觉平衡、色彩、 图形、整体风格等。
                      </span>
                    </li>
                    <li className="mb-4">
                      <strong className="d-block text-white">完成度（30%）</strong>
                      <span className="d-block">参赛团队提供的作品实现程度。</span>
                    </li>
                    <li className="mb-0">
                      <strong className="d-block text-white">代码质量（10%）</strong>
                      <span className="d-block">参赛团队提供的代码的规范性，如代码整洁、代码注释等。</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-xl-6 mb-4 mb-xl-0">
                <div className="blueDiv line-height-175">
                  <h3 className="text-primary mb-4">赛题二：使用 Agora SDK 开发应用</h3>
                  <ul className="pl-4">
                    <li className="mb-4">
                      <strong className="d-block text-white">完成度（40%）</strong>
                      <span className="d-block">参赛团队提供的作品实现程度。</span>
                    </li>
                    <li className="mb-4">
                      <strong className="d-block text-white">创意度（20%）</strong>
                      <span className="d-block">
                        参赛作品的创新程度。是否具备充分的创新性，与行业内同类产品具有差异性。
                      </span>
                    </li>
                    <li className="mb-4">
                      <strong className="d-block text-white">实用性（20%）</strong>
                      <span className="d-block">
                        参赛作品在应用场景中的实际应用程度。是否能够匹配用户的发展诉求，注重用户体验。
                      </span>
                    </li>
                    <li className="mb-0">
                      <strong className="d-block text-white">潜在商业价值（20%）</strong>
                      <span className="d-block">
                        参赛作品可以在日常工作生活中产生的商业价值。是否能够引起行业关注和足够的影响力以及创造市场效益。
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ColumnSection>
        <ColumnSection hid="n7" title="报名参赛">
          <div className="row">
            <div className="col-12 col-lg-5">
              <h4 className="text-primary mb-3">参赛对象</h4>
              <span className="d-block mb-5">
                高校学生、创业者、创客企业、个人开发者，只要你爱 Coding，我们都欢迎（所有未受雇于 Agora.io
                的人员均可参赛）
              </span>
              <h4 className="text-primary mb-3">参与报名</h4>
              <span className="d-block mb-5">
                开发者以个人身份报名，团队的每个成员都要单独报名。报名后官方会对报名人员进行筛选。
              </span>
              <h4 className="text-primary mb-3">团队规模</h4>
              <span className="d-block mb-5">
                本次比赛要求组队参加，每个团队 1-5 人，团队最高人限 5 人，1 人只能参与 1 个团队。
              </span>
              <span className="d-block mb-3">欢迎微信扫描二维码 进入“RTC 线上编程挑战赛 春季赛”交流群</span>
              <img
                width="180px"
                src={require('./assets/img/qrcode.svg')}
                className="d-inline-block rounded mb-3"
                alt=""
              />
            </div>
            <div className="col-12 col-lg-7" id="scriptForm" />
          </div>
        </ColumnSection>
        <ColumnSection hid="n8" title="活动主办">
          <div className="text-center">
            <img width="240px" src={require('./assets/img/logo/rtc.svg')} className="mx-md-5 my-1 img-fluid" alt="" />
            <img width="240px" src={require('./assets/img/logo/agora.svg')} className="mx-md-5 my-1 img-fluid" alt="" />
          </div>

          <div className="text-center">
            <h3 className="my-5">合作伙伴</h3>
            <img
              height="40px"
              style={{ height: '40px' }}
              src={require('./assets/img/logo/sf.svg')}
              className="mx-md-5 my-1 img-fluid"
              alt=""
            />
            <img
              height="80px"
              style={{ height: '80px' }}
              src={require('./assets/img/logo/华科联创@2x.png')}
              className="mx-md-5 my-2 img-fluid"
              alt=""
            />
            <img
              height="67px"
              style={{ height: '67px' }}
              src={require('./assets/img/logo/杭电@2x.png')}
              className="mx-md-5 my-2 img-fluid"
              alt=""
            />
            <img
              height="68px"
              style={{ height: '68px' }}
              src={require('./assets/img/logo/广州大学@2x.png')}
              className="mx-md-5 my-2 img-fluid"
              alt=""
            />
            <img
              height="55px"
              style={{ height: '55px' }}
              src={require('./assets/img/logo/开源中国@2x.png')}
              className="mx-md-5 my-2 img-fluid"
              alt=""
            />
          </div>
        </ColumnSection>
        <footer className="text-center">
          <span>RTC 线上编程挑战赛 秋季赛，7月开启，拭目以待</span>
        </footer>
      </>
    )
  }
}

export default Agora
